import React, { useState, useMemo } from 'react';

// This function is memo-ised so that the div is not re-rendered on table load.
// If it wasn't, the screen reader misses it.

export const useScreenReaderAnnouncement = () => {
    const [srAnnouncement, setSrAnnouncement] = useState('');

    const LiveRegion = useMemo(() => {
        return function LiveRegion({ message }) {
            return (
                <div aria-live="polite" aria-atomic="true" className="ch-sr-only">
                    {message}
                </div>
            );
        };
    }, []);

    return { setSrAnnouncement, LiveRegion, srAnnouncement };
};